require('angulartics')
require('angulartics-ga')
require('angulartics-mixpanel')

modules = [
  'angulartics'
  'angulartics.google.analytics'
  'angulartics.mixpanel'
]

angular.module 'gnp-analyze-access', modules


// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/components/analyze-access/analyze-access-module.coffee